export const WORKING_HOURS = 'з 8:00 до 21:00';
export const WORK_HOURS = '8:00 до 21:00';
export const WORKING_HOURS_EXT = `${WORKING_HOURS} без вихідних`;
